import React, { useState, useEffect } from 'react';
import { ReferenceInput, AutocompleteInput } from 'react-admin';

export const CategoryParentInput = ({ edit, company }) => {
  const [filter, setFilter] = useState(null);

  useEffect(() => {
    if (company) {
      setFilter({ company: company });
    }
  }, [company]);

  const filterToQuery = (searchText) => ({
    'translations.name': searchText,
  });

  return (
    <ReferenceInput
      source={edit ? 'parent.@id' : 'parent'}
      reference="categories"
      label="Parent"
      filter={filter}
    >
      <AutocompleteInput
        fullWidth
        label={'Parent'}
        optionText="labelView"
        debounce={500}
        filterToQuery={filterToQuery}
      />
    </ReferenceInput>
  );
};
